<template>
    <div class="Notifications">
      <Loading v-if="loading" />
      <template v-else>
        <h3 class="subTitle">Notifications</h3>
        <p>I want to receive email notifications about:</p>
            <ul>
                <li v-for="(notification, index) in notifications" :key="index">
                <WCheckbox
                    :disabled="profile !== null && profile.account_disabled"
                    :checked="form[notification.value]"
                    @change="
                    (checked) => handlePlatformCheck(notification.value, checked)
                    "
                />
                <span>{{ notification.label }}</span>
                </li>
            </ul>
            <div class="bottom">
              <w-button :spinner="spinner" type="submit" @click="saveProfile" class="button--large"> Save </w-button>
            </div>
      </template>
    </div>
</template>
<script>
  import { mapState, mapMutations, mapActions } from 'vuex';
  import notifications from '../../../../assets/data/notifications.json';

  export default {
    name: 'Notifications',
    data() {
      return {
        notifications,
        screen: window.innerWidth,
        loading: false,
        spinner: false,
        form: {},
      };
    },
    async created() {
      this.loading = true;
      await this.doGetProfile();
      this.form = JSON.parse(JSON.stringify(this.profile));
      this.loading = false;
    },
    computed: {
      ...mapState('Auth', ['profile']),
    },
    methods: {
      ...mapActions('Auth', ['doGetProfile']),
      ...mapActions('Profile', ['doUpdateProfile']),
      ...mapMutations('Profile', ['setSuccess']),
      async saveProfile() {
        this.spinner = true;
        try {
          await this.doUpdateProfile(this.form);
          this.setSuccess('Success! Your notifications preferences have been updated.');
          this.spinner = false;
        } catch (e) {
          // console.log(e);
        }
      },
      handlePlatformCheck(val, flag) {
        this.form[val] = !!flag;
      },
    },
  };
</script>

<style lang="scss">
@import "../../../../assets/styles/variables";
.Notifications {
  h3 {
    margin-bottom: 24px;
  }
  p {
    font-family: "Roboto", sans-serif;
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 18px;
    color: #9b9b9d;
    margin-bottom: 16px;
  }
  ul {
    li {
      font-family: "Roboto", sans-serif;
      font-style: normal;
      font-weight: normal;
      font-size: 14px;
      line-height: 18px;
      color: #1a1a1d;
      margin: 16px 0;
      display: flex;
      align-items: center;
      span {
        margin-left: 16px;
      }
    }
  }
  .bottom {
    margin-top: 28px;
    width: 200px;
    .button--large {
      width: 100%;
    }
  }
}
</style>
